import { isInstalledPWA } from '@/Utils/Browser';
import { displayModeTypes } from '@/Utils/PwaUtility';
import { isIOSApp } from '@/Utils/PwaUtility';

const getDisplayModeValues = (displayModes, displayMode) => ({
    isPWA: displayMode === displayModes.pwa,
    isWeb: displayMode === displayModes.web,
    currentModeName: displayMode,
});

export const displayMode = isInstalledPWA() || isIOSApp() ? displayModeTypes.pwa : displayModeTypes.web;
export const displayModeValues = getDisplayModeValues(displayModeTypes, displayMode);

const setDisplayModeAttribute = () => {
    document.body.setAttribute('data-display-mode', displayMode);
};

let displayModeAttributeSet = false;
const ensureDisplayModeAttribute = () => {
    if (displayModeAttributeSet) {
        return;
    }
    displayModeAttributeSet = true;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setDisplayModeAttribute, { once: true });
        return;
    }

    setDisplayModeAttribute();
};

export default {
    install(app) {
        ensureDisplayModeAttribute();
        app.mixin({
            computed: {
                $displayMode() {
                    return {
                        ...displayModeValues,
                    };
                },
            },
        });
    },
};